var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-element-permissions",
    },
    [
      _c(
        "label",
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userPermsReadAll,
                expression: "userPermsReadAll",
              },
            ],
            staticClass: "default",
            attrs: {
              type: "checkbox",
            },
            domProps: {
              checked: Array.isArray(_vm.userPermsReadAll)
                ? _vm._i(_vm.userPermsReadAll, null) > -1
                : _vm.userPermsReadAll,
            },
            on: {
              change: function change($event) {
                var $$a = _vm.userPermsReadAll,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.userPermsReadAll = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.userPermsReadAll = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.userPermsReadAll = $$c
                }
              },
            },
          }),
          _vm._v(" "),
          _c("translate", [_vm._v("Alle Teilnehmenden haben Leserechte")]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "label",
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userPermsWriteAll,
                expression: "userPermsWriteAll",
              },
            ],
            staticClass: "default",
            attrs: {
              type: "checkbox",
            },
            domProps: {
              checked: Array.isArray(_vm.userPermsWriteAll)
                ? _vm._i(_vm.userPermsWriteAll, null) > -1
                : _vm.userPermsWriteAll,
            },
            on: {
              change: function change($event) {
                var $$a = _vm.userPermsWriteAll,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.userPermsWriteAll = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.userPermsWriteAll = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.userPermsWriteAll = $$c
                }
              },
            },
          }),
          _vm._v(" "),
          _c("translate", [_vm._v("Alle Teilnehmenden haben Schreibrechte")]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.autor_members.length
        ? _c(
            "table",
            {
              staticClass: "default",
            },
            [
              _c("caption", [_c("translate", [_vm._v("Studierende")])], 1),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("thead", [
                _c("tr", [
                  _c("th", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.bulkSelectAutorRead,
                          expression: "bulkSelectAutorRead",
                        },
                      ],
                      attrs: {
                        type: "checkbox",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.bulkSelectAutorRead)
                          ? _vm._i(_vm.bulkSelectAutorRead, null) > -1
                          : _vm.bulkSelectAutorRead,
                      },
                      on: {
                        click: function click($event) {
                          return _vm.handleBulkSelectRead($event, "autor")
                        },
                        change: function change($event) {
                          var $$a = _vm.bulkSelectAutorRead,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.bulkSelectAutorRead = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.bulkSelectAutorRead = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.bulkSelectAutorRead = $$c
                          }
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("th", [_c("translate", [_vm._v("Lesen")])], 1),
                  _vm._v(" "),
                  _c("th", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.bulkSelectAutorWrite,
                          expression: "bulkSelectAutorWrite",
                        },
                      ],
                      attrs: {
                        type: "checkbox",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.bulkSelectAutorWrite)
                          ? _vm._i(_vm.bulkSelectAutorWrite, null) > -1
                          : _vm.bulkSelectAutorWrite,
                      },
                      on: {
                        click: function click($event) {
                          return _vm.handleBulkSelectWrite($event)
                        },
                        change: function change($event) {
                          var $$a = _vm.bulkSelectAutorWrite,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.bulkSelectAutorWrite = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.bulkSelectAutorWrite = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.bulkSelectAutorWrite = $$c
                          }
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "th",
                    [_c("translate", [_vm._v("Lesen und Schreiben")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("th", [_c("translate", [_vm._v("Name")])], 1),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.autor_members_filtered, function (user) {
                  return _c(
                    "tr",
                    {
                      key: user.user_id,
                    },
                    [
                      _c(
                        "td",
                        {
                          staticClass: "perm",
                          attrs: {
                            colspan: "2",
                          },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.userPermsReadUsers,
                                expression: "userPermsReadUsers",
                              },
                            ],
                            attrs: {
                              type: "checkbox",
                              id: user.user_id + "_read",
                            },
                            domProps: {
                              value: user.user_id,
                              checked: Array.isArray(_vm.userPermsReadUsers)
                                ? _vm._i(_vm.userPermsReadUsers, user.user_id) >
                                  -1
                                : _vm.userPermsReadUsers,
                            },
                            on: {
                              change: function change($event) {
                                var $$a = _vm.userPermsReadUsers,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = user.user_id,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.userPermsReadUsers = $$a.concat([
                                        $$v,
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.userPermsReadUsers = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.userPermsReadUsers = $$c
                                }
                              },
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "perm",
                          attrs: {
                            colspan: "2",
                          },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.userPermsWriteUsers,
                                expression: "userPermsWriteUsers",
                              },
                            ],
                            attrs: {
                              type: "checkbox",
                              id: user.user_id + "_write",
                            },
                            domProps: {
                              value: user.user_id,
                              checked: Array.isArray(_vm.userPermsWriteUsers)
                                ? _vm._i(
                                    _vm.userPermsWriteUsers,
                                    user.user_id
                                  ) > -1
                                : _vm.userPermsWriteUsers,
                            },
                            on: {
                              change: function change($event) {
                                var $$a = _vm.userPermsWriteUsers,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = user.user_id,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.userPermsWriteUsers = $$a.concat([
                                        $$v,
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.userPermsWriteUsers = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.userPermsWriteUsers = $$c
                                }
                              },
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "label",
                          {
                            attrs: {
                              for: user.user_id + "_read",
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(user.formattedname) +
                                "\n                        "
                            ),
                            _c("i", [_vm._v(_vm._s(user.username))]),
                          ]
                        ),
                      ]),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _vm.can_paginate &&
              _vm.autor_members.length > _vm.entries_per_page
                ? _c("tfoot", [
                    _c("tr", [
                      _c(
                        "td",
                        {
                          attrs: {
                            colspan: "5",
                          },
                        },
                        [
                          _c("studip-pagination", {
                            attrs: {
                              currentOffset: _vm.autorOffset,
                              totalItems: _vm.autor_members.length,
                              itemsPerPage: _vm.entries_per_page,
                            },
                            on: {
                              updateOffset: _vm.updateAutorOffset,
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.user_members.length
        ? _c(
            "table",
            {
              staticClass: "default",
            },
            [
              _c("caption", [_c("translate", [_vm._v("Leser/-innen")])], 1),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c("thead", [
                _c("tr", [
                  _c("th", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.bulkSelectUserRead,
                          expression: "bulkSelectUserRead",
                        },
                      ],
                      attrs: {
                        type: "checkbox",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.bulkSelectUserRead)
                          ? _vm._i(_vm.bulkSelectUserRead, null) > -1
                          : _vm.bulkSelectUserRead,
                      },
                      on: {
                        click: function click($event) {
                          return _vm.handleBulkSelectRead($event, "user")
                        },
                        change: function change($event) {
                          var $$a = _vm.bulkSelectUserRead,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.bulkSelectUserRead = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.bulkSelectUserRead = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.bulkSelectUserRead = $$c
                          }
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("th", [_c("translate", [_vm._v("Lesen")])], 1),
                  _vm._v(" "),
                  _c("th", [_c("translate", [_vm._v("Name")])], 1),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.user_members_filtered, function (user) {
                  return _c(
                    "tr",
                    {
                      key: user.user_id,
                    },
                    [
                      _c(
                        "td",
                        {
                          attrs: {
                            colspan: "2",
                          },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.userPermsReadUsers,
                                expression: "userPermsReadUsers",
                              },
                            ],
                            attrs: {
                              type: "checkbox",
                              id: user.user_id + "_read",
                            },
                            domProps: {
                              value: user.user_id,
                              checked: Array.isArray(_vm.userPermsReadUsers)
                                ? _vm._i(_vm.userPermsReadUsers, user.user_id) >
                                  -1
                                : _vm.userPermsReadUsers,
                            },
                            on: {
                              change: function change($event) {
                                var $$a = _vm.userPermsReadUsers,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = user.user_id,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.userPermsReadUsers = $$a.concat([
                                        $$v,
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.userPermsReadUsers = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.userPermsReadUsers = $$c
                                }
                              },
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "label",
                          {
                            attrs: {
                              for: user.user_id + "_read",
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(user.firstname) +
                                "\n                        " +
                                _vm._s(user.lastname) +
                                "\n                        "
                            ),
                            _c("i", [_vm._v(_vm._s(user.username))]),
                          ]
                        ),
                      ]),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _vm.can_paginate && _vm.user_members.length > _vm.entries_per_page
                ? _c("tfoot", [
                    _c("tr", [
                      _c(
                        "td",
                        {
                          attrs: {
                            colspan: "3",
                          },
                        },
                        [
                          _c("studip-pagination", {
                            attrs: {
                              currentOffset: _vm.userOffset,
                              totalItems: _vm.user_members.length,
                              itemsPerPage: _vm.entries_per_page,
                            },
                            on: {
                              updateOffset: _vm.updateUserOffset,
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.groups.length
        ? _c(
            "table",
            {
              staticClass: "default",
            },
            [
              _c("caption", [_c("translate", [_vm._v("Gruppen")])], 1),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _c("thead", [
                _c("tr", [
                  _c("th", [_c("translate", [_vm._v("Lesen")])], 1),
                  _vm._v(" "),
                  _c(
                    "th",
                    [_c("translate", [_vm._v("Lesen und Schreiben")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("th", [_c("translate", [_vm._v("Name")])], 1),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.groups, function (group) {
                  return _c(
                    "tr",
                    {
                      key: group.id,
                    },
                    [
                      _c(
                        "td",
                        {
                          staticClass: "perm",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.userPermsReadGroups,
                                expression: "userPermsReadGroups",
                              },
                            ],
                            attrs: {
                              type: "checkbox",
                              id: group.id + "_read",
                            },
                            domProps: {
                              value: group.id,
                              checked: Array.isArray(_vm.userPermsReadGroups)
                                ? _vm._i(_vm.userPermsReadGroups, group.id) > -1
                                : _vm.userPermsReadGroups,
                            },
                            on: {
                              change: function change($event) {
                                var $$a = _vm.userPermsReadGroups,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = group.id,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.userPermsReadGroups = $$a.concat([
                                        $$v,
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.userPermsReadGroups = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.userPermsReadGroups = $$c
                                }
                              },
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "perm",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.userPermsWriteGroups,
                                expression: "userPermsWriteGroups",
                              },
                            ],
                            attrs: {
                              type: "checkbox",
                              id: group.id + "_write",
                            },
                            domProps: {
                              value: group.id,
                              checked: Array.isArray(_vm.userPermsWriteGroups)
                                ? _vm._i(_vm.userPermsWriteGroups, group.id) >
                                  -1
                                : _vm.userPermsWriteGroups,
                            },
                            on: {
                              change: function change($event) {
                                var $$a = _vm.userPermsWriteGroups,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = group.id,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.userPermsWriteGroups = $$a.concat([
                                        $$v,
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.userPermsWriteGroups = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.userPermsWriteGroups = $$c
                                }
                              },
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "label",
                          {
                            attrs: {
                              for: group.id + "_read",
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(group.name) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c("colgroup", [
      _c("col", {
        staticStyle: {
          width: "1%",
        },
      }),
      _vm._v(" "),
      _c("col", {
        staticStyle: {
          width: "19%",
        },
      }),
      _vm._v(" "),
      _c("col", {
        staticStyle: {
          width: "1%",
        },
      }),
      _vm._v(" "),
      _c("col", {
        staticStyle: {
          width: "29%",
        },
      }),
      _vm._v(" "),
      _c("col", {
        staticStyle: {
          width: "50%",
        },
      }),
    ])
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c("colgroup", [
      _c("col", {
        staticStyle: {
          width: "1%",
        },
      }),
      _vm._v(" "),
      _c("col", {
        staticStyle: {
          width: "39%",
        },
      }),
      _vm._v(" "),
      _c("col", {
        staticStyle: {
          width: "50%",
        },
      }),
    ])
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c("colgroup", [
      _c("col", {
        staticStyle: {
          width: "20%",
        },
      }),
      _vm._v(" "),
      _c("col", {
        staticStyle: {
          width: "35%",
        },
      }),
      _vm._v(" "),
      _c("col", {
        staticStyle: {
          width: "45%",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }